import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import Version1 from './Version1/Version1'
import Version2 from './Version2/Version2'
import Version3 from './Version3/Version3'

import './CollageBanner.css';

import {
  PageSection,
  Container,
  Clearfix,
} from './CollageBanner.css.js';

const CollageBanner = ({ config, content }) => {
  const { backgroundColor, sectionVerticalPaddingSize, layoutVersion } = config;
  const { title, description, imageOne, imageTwo, imageThree } = content;

  const renderLayoutVersionOne = () => (
    <Version1 {...content} />
  );

  const renderLayoutVersionTwo = () => (
    <Version2 {...content} />
  );

  const renderLayoutVersionThree = () => (
    <Version3 {...content} />
  );

  return (
    <PageSection
      backgroundColor={backgroundColor}
    >
      <Container
        removeGutters={true}
        sectionVerticalPaddingSize={sectionVerticalPaddingSize}
      >
        {layoutVersion === `one` && renderLayoutVersionOne()}
        {layoutVersion === `two` && renderLayoutVersionTwo()}
        {layoutVersion === `three` && renderLayoutVersionThree()}
      </Container>

      <Clearfix />
    </PageSection>
  );
}

CollageBanner.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    sectionVerticalPaddingSize: PropTypes.oneOf([`x-large`, `large`, `medium`, `small`, `none`]),
    layoutVersion: PropTypes.oneOf([`one`, `two`, `three`]).isRequired,
  }),
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    imageOne: PropTypes.string.isRequired,
    imageTwo: PropTypes.string.isRequired,
    imageThree: PropTypes.string,
  }),
}

export default CollageBanner;
